import { createFileRoute } from "@tanstack/react-router"

// Import the existing chat inbox page
import Inbox from "@/features/jobs/manage/components/manage-chat-page"

type ChatSearchParams = {
  shopName?: string
  otherUserId?: string
  submissionId?: string
}

export const Route = createFileRoute("/_screen/manage/chat/$code")({
  validateSearch: (search: Record<string, unknown>): ChatSearchParams => {
    return {
      shopName: search.shopName as string | undefined,
      otherUserId: search.otherUserId as string | undefined,
      submissionId: search.submissionId as string | undefined
    }
  },
  component: ChatInboxPage
})

function ChatInboxPage() {
  const { code } = Route.useParams()
  const search = Route.useSearch()
  return <Inbox code={code} key={code} {...search} />
}
